import { FreightClass } from "../../../api/graphql/generated";

export const getFreightClass = (density: number): FreightClass => {
  if (density >= 50) {
    return FreightClass.Fc_50;
  }
  if (density >= 35) {
    return FreightClass.Fc_55;
  }
  if (density >= 30) {
    return FreightClass.Fc_60;
  }
  if (density >= 22.5) {
    return FreightClass.Fc_65;
  }
  if (density >= 15) {
    return FreightClass.Fc_70;
  }
  if (density >= 13.5) {
    return FreightClass.Fc_77_5;
  }
  if (density >= 12) {
    return FreightClass.Fc_85;
  }
  if (density >= 10.5) {
    return FreightClass.Fc_92_5;
  }
  if (density >= 9) {
    return FreightClass.Fc_100;
  }
  if (density >= 8) {
    return FreightClass.Fc_110;
  }
  if (density >= 7) {
    return FreightClass.Fc_125;
  }
  if (density >= 6) {
    return FreightClass.Fc_150;
  }
  if (density >= 5) {
    return FreightClass.Fc_175;
  }
  if (density >= 4) {
    return FreightClass.Fc_200;
  }
  if (density >= 3) {
    return FreightClass.Fc_250;
  }
  if (density >= 2) {
    return FreightClass.Fc_300;
  }
  if (density >= 1) {
    return FreightClass.Fc_400;
  }
  return FreightClass.Fc_500;
};
